export default __webpack_public_path__ + "static/media/Belt_for_Bucket_Eleavtor-removebg-preview (2).e5839192.png";